module.exports = __webpack_public_path__ + "img/logo@3x.de790399.png";